import {
  OwnUpBody,
  OwnUpFloatingModal,
  OwnUpModalProps,
  OwnUpTooltip,
  OwnUpUnderlineTooltipTrigger,
  PropsWithTheme
} from '@rategravity/own-up-component-library';
import React, { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';

const SubtitleWrapper = styled(OwnUpBody)`
  margin: 0;
`;

interface ModalPorps extends Pick<OwnUpModalProps, 'open' | 'onClose'> {
  title: string;
  description: React.JSX.Element;
}
export const ExplanationModal = ({ open, onClose, title, description }: ModalPorps) => {
  return (
    <OwnUpFloatingModal title={title} open={open} onClose={onClose}>
      {description}
    </OwnUpFloatingModal>
  );
};

const SmallScreenContainer = styled.span`
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.up('md')} {
    display: none;
  }
`;

const LargeScreenContainer = styled.span`
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('sm')} {
    display: none;
  }
`;

export type TooltipWrapperProps = {
  title: string;
  description: React.JSX.Element;
  className?: string;
};

export const TooltipWrapper: React.FC<TooltipWrapperProps> = ({
  title,
  description
}: TooltipWrapperProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleClick = useCallback(() => {
    setModalOpen(true);
  }, []);
  const closeModal = () => {
    console.log('closing');
    setModalOpen(false);
  };

  const smallScreenTooltip = useMemo(
    () => (
      <SmallScreenContainer>
        <OwnUpTooltip onClick={handleClick} description open={false}>
          <OwnUpUnderlineTooltipTrigger className="underline">{title}</OwnUpUnderlineTooltipTrigger>
        </OwnUpTooltip>
        <ExplanationModal
          open={modalOpen}
          onClose={closeModal}
          title={title}
          description={description}
        />
      </SmallScreenContainer>
    ),
    [modalOpen, handleClick, title, description]
  );

  const largeScreenTooltip = useMemo(
    () => (
      <LargeScreenContainer>
        <OwnUpTooltip description={description}>
          <OwnUpUnderlineTooltipTrigger className="underline">{title}</OwnUpUnderlineTooltipTrigger>
        </OwnUpTooltip>
      </LargeScreenContainer>
    ),
    [title, description]
  );

  return (
    <SubtitleWrapper variant="body1">
      {smallScreenTooltip}
      {largeScreenTooltip}
    </SubtitleWrapper>
  );
};
